<template>
  <div class="grid login">
    <div class="container">
      <header>
        <Icon/>
        <h1 class="title">thwack tracker</h1>
      </header>
      <main class="section">
        <div class="columns is-centered">
          <div class="column is-7-tablet is-5-desktop">
            <div class="box">
              <form @submit.prevent="login()">
                <div class="field">
                  <p class="control has-icons-left">
                    <input 
                    class="input is-medium"
                    type="email" 
                    name="email"
                    id="email"
                    v-model="email" 
                    placeholder="Email address" 
                    required>
                    <span class="icon is-left">
                      <i class="fas fa-envelope"></i>
                    </span>
                  </p>
                </div>
                <div class="field">
                  <p class="control has-icons-left">
                    <input 
                    class="input is-medium"
                    type="password" 
                    name="password"
                    id="password"
                    v-model="password"
                    placeholder="Password" 
                    required>
                    <span class="icon is-left">
                      <i class="fas fa-key"></i>
                    </span>
                  </p>
                </div>
                <div class="field">
                  <p class="control">
                    <button type="submit" class="button is-link is-fullwidth is-medium">Log in</button>
                  </p>
                </div>
              </form>
              <p class="login-footer">
                <router-link to="/signup">New Here? Create a new account</router-link>
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import Icon from '../components/Icon.vue'
export default {
  name: 'login',
  data () {
    return {
      email: '',
      password: ''
    }
  },
  computed: {
    ...mapGetters(['user']),
    nextRoute () {
      return this.$route.query.redirect || '/'
    }
  },
  watch: {
    user (auth) {
      if(!!auth){
        this.$router.replace(this.nextRoute)
      }
    }
  },
  methods: {
    async login () {
      const auth = await this.$auth.login(this.email, this.password)
    }
  },
  components: {
    Icon,
  }
}
</script>
<style scoped>
.login {
  /* display: flex; */
  /* flex-direction: column; */
  justify-content: center;
  /* min-height: 100vh; */
  padding: 20px 0;
}
.login-footer {
  margin-top: 1em;
}
.container {
  width: 100%;
}
.icon {
  height: auto;
  width: auto;
  margin-bottom: 1em;
}
.tt-icon {
  max-width: 300px;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/views/Login.vue